export default {
  titles: {
    'choose-service-color': 'Choose Service Color',
    'add-question': 'Add Question',
    'edit-question': 'Edit Question',
    'note-to-customer': 'Message to Client',
    'questions-to-client': 'Questions to Client',
    'duration-pricing': 'Duration / Pricing',
    'service-details': 'Service Details',
    'combo-service-details': 'Combo Service Details',
    'delete-service': 'Delete service?',
    'delete-service-with-conflicts': 'Confirm deleting service and associated combo services',
    'update-service-with-conflicts': 'Confirm deleting service and associated combo services',
    'customer-booking': 'Allow self-booking',
    'mobile-service': 'Mobile Service',
    'video-chat': 'Virtual Appointments',
    'service-color': 'Service Color',
    'color': 'Color',
    interval: 'Booking Intervals',
    'padding-time': 'Padding Time',
    'processing-time-during-service': 'Processing time during the service',
    'processing-time-afer-service': 'Processing time after the service',
    'parallel-clients': 'Parallel Clients',
    'tax-rate': 'Tax Rate',
    'your-time': 'Your Time Is Your Money',
    'cancellation-fees': 'Cancellation Fees',
    'no-services': 'No service added yet.',
    off: 'Off',
    'cancellation-fee': 'Cancellation Fee',
    prepayment: 'Deposit',
    prepayments: 'Deposits',
    'voucher-conflict': 'This service is assigned to some vouchers. Would you like to continue deleting?',
    'main-details': 'Main details (required)',
    'additional-details': 'Additional details',
    'create-add-on': 'Create add-on',
  },
  texts: {
    'turn-on': 'Turn on',
    'category-services': 'Define how many services are expanded under each category. <br/>This will be visible for your customers only.',
    'default-service-color': 'Default service color',
    'set-service-color': 'Booksy will automatically set service color.',
    'note-to-customer': 'This message will be sent to your client before the appointment.',
    'save-and-next-service': 'Save & Add Next Service',
    'add-service': 'Add Service',
    'edit-service': 'Edit Service',
    'customer-booking-hint': 'If switched off your clients will not be able to self-book through Booksy. You will need to add appointments for this service yourself.',
    'delete-service': 'By deleting service you will lose all info, photos etc.<br/>This action cannot be undone.',
    'delete-service-with-conflicts': 'This service is assigned to at least one combo service. If you delete it, the associated combo services will also be deleted. This action cannot be undone. Are you sure you want to continue?',
    'delete-service-with-conflicts-cta': 'Delete service & associated combo services',
    'update-service-with-conflicts': 'You have deleted at least one service variant which is assigned to a combo service. If you save changes, the associated combo service will also be deleted. This action cannot be undone. Are you sure you want to continue?',
    'update-service-with-conflicts-cta': 'Save and delete associated combo services',
    'mobile-services-desc1': 'This service is set up to be done in your client\'s home. You will need to travel to them in order to complete the service.',
    'mobile-services-desc2': 'When a client books a travel service, you\'ll have to review the distance, adjust traveling cost, and bake in transit time on your calendar.',
    'mobile-services-desc3': 'Your business is set as only offering services from your clients locations.',
    'mobile-services-desc4': 'If you want to also add the option to provide services from your shop, go to Business Profile > Location & Traveling and choose "At my place and client\'s location."',
    'mobile-services-desc5': 'If this option is checked it means you\'re willing to travel to your clients to perform this service. You have the ability to customize this setting for each service.',
    'mobile-services-desc6': 'To edit enable Mobile Services or adjust your settings please visit Business Details > Location & Mobile Services.',
    'video-chat': 'Enabling this feature will allow you to offer this service virtually. Clients will continue to book as usual. From there you\'ll both receive a dedicated link so that you can connect online during the scheduled appointment time.',
    interval: 'Define the time intervals for your bookings. Example: Setting a 15-minute booking interval will allow bookings at 9:00, 9:15, 9:30, and 9:45. A 30-minute interval will allow bookings at 9:00 and 9:30.',
    'padding-time': 'Pad on extra time before or after your appointments to allow for cleaning, admin work, etc. Clients will not be able to book during these times. Applies to future bookings - existing appointments won\'t be impacted.',
    'processing-time-during-service': 'Set a processing time for this service and allow other clients to book within that time frame. This allows you to take appointments even though you already have another client on the books.',
    'processing-time-afer-service': 'Processing time after the service lets you create a bookable space for another client between two services (e.g. color and cut).',
    'prepayment': ' When clients book you online, they will pay partial or the full price of the service upfront. The deposit will be deducted from total on checkout.',
    'cancelation-fee': 'When clients book you online, they will add their credit card on file. If a client cancels last minute or misses the appointment, you can charge the cancellation fee.',
    'income-schedule': 'guarantee your income on your own terms and fully control your schedule',
    'your-time-1': 'Protect both with Deposits and Cancellation Fees.',
    'your-time-2': 'Charge your clients a portion of the service charge at the time of booking.',
    'cancellation-fees': 'Charge clients a set fee if they miss their appointment or cancel on short notice.',
    'no-show-protection-prepayment-1': 'Client pays',
    'no-show-protection-prepayment-2': 'of the service price upfront',
    'no-show-protection-cancelation-fee-1': 'You can charge',
    'no-show-protection-cancelation-fee-2': 'of service in case of no-show',
    'no-services': 'Build out a list of services for this category',
    'voucher-conflict': 'This action cannot be undone.',
    'no-show-protection-hint-off': 'Clients will not be required to keep their billing information on file, you will check them out in full once the service has been completed.',
    'no-show-protection-hint-cancellation-fee': 'When clients book with you they\'ll be prompted to keep their credit card on file. If a client cancels last minute or doesn\'t show up you have the option of processing the cancellation fee, or waiving the charge.',
    'no-show-protection-hint-prepayment': 'When clients book with you they\'ll be prompted to make a payment up front - either for part of their service, or the full amount. When you check them out following their appointment the deposit will be deducted from their total.',
    'resources-list-empty': 'No Resources yet',
    'parallel-clients': 'Set the maximum number of clients that can book this service at the same exact time.',
    'tax-rate': 'Customize your tax rate based on the regulations of your region/state.',
    'type-service': 'Try type service name properly.',
    'no-video-provider': 'Can\'t mark service as online. You don\'t have Zoom account configured. Please contact our support.',
    'delete-conflict': 'Delete & ignore conflict',
    'medical-service': 'Medical service',
    'settings-med': 'Settings med',
    'service-type-hint': 'Assigning a service type helps clients find what they are looking for and can also help new clients to discover you and your services. If you cannot find a service type that fits you can select "unassigned" - but do note that unassigned services are less likely to be found in search.',
    'assign-services': 'Assign: {count} Service | Assign: {count} Services | Assign: {count} Services',
    'assign-success': 'Successfully assigned: {count} Service | Successfully assigned: {count} Services | Successfully assigned: {count} Services',
    'assignment-thank-you': {
      'title': 'Congratulations',
      'subtitle': 'You’ve successfully assigned Service Types to all your services. Clients can easily find and book services with you now.<br /><br />You can change the Service Type at any time by editing the service.',
      'confirm': 'Got it',
    },
    'add-service-variant-hint': 'Add a variant to this service to provide a more customized service for your clients.<br/><br/>Examples of variants could include: long and short hair for haircuts or with or without a blow dry.<br/><br/> You can customize the time and price needed for each variant.',
    'addons-linked': '{count} add-on linked | {count} add-ons linked | {count} add-ons linked',
    'no-addons-linked': 'No add-ons linked',
  },
  labels: {
    'display-mode': 'Display mode',
    'question': 'Question',
    'note-to-customer': 'Message',
    'service-name': 'Service Name',
    category: 'Menu Category',
    'service-category': 'Service Category',
    description: 'Description',
    duration: 'Duration',
    'price-type': 'Price type',
    price: 'Price',
    'no-show-protection': 'No-Show Protection',
    'cancelation-fee': 'Cancellation Fee',
    'new-service': 'New service',
    'new-combo': 'New combo service',
    'new-category': 'New category',
    'add-media': 'Add media',
    'add-photos': {
      long: 'Add photos',
    },
    'add-pricing': 'Add Service Variant',
    'service-variant-name': 'Service Variant Name',
    'delete-photo': 'Delete photo',
    all: 'All Categories',
    'performs-label': 'Performs',
    categories: {
      'show-all': 'Show all',
      'show-first': 'Show first 5 services',
      'show-none': 'Show none',
    },
    rules: {
      none: '–',
      after: 'After',
      before: 'Before',
      both: 'Before & after',
    },
    'max-length': 'Question cannot be longer than 256 characters',
    'all-service-variants': 'All Service Variants',
    'select-service-variants': 'Select Service Variants',
    'service-type': 'Service Type',
    'suggested-service-types': 'Suggested Service Types',
    'all-service-types': 'All Service Types',
    'unassigned-subtitle': 'Can’t see a perfect match?',
    'service-description': 'Service Description',
    'add-on': 'Add-on',
  },
  placeholders: {
    'add-your-question': 'Add your question',
    'note-to-customer': 'E.g. Please do not eat 1 hour before the appointment.',
    'search-in-services': 'Search in services...',
  },
  toasts: {
    'service-created': 'Service has been added',
    'service-updated': 'Service has been updated',
    'service-deleted': 'Service has been deleted',
    'category-created': 'Category has been added',
  },
  tabs: {
    'general': 'general',
    'staff': 'staff',
    'resources': 'resources',
    'details': 'details',
    'no-show-protection': 'no-show protection',
    'settings': 'settings',
    'for-client': 'for client',
    'combo-services': 'combo services',
  },
  validation: {
    maxLength: 'Ensure this field has no more than {characters} characters.',
    validNumberRequired: 'A valid number is required.',
  },
  'no-show-protection': {
    'missing-pricing': 'Missing Service Pricing',
    'missing-pricing-text': 'No-Show Protection can only be applied to Services that have a price associated with them. It looks like pricing for some of your Services is set to "Varies", "Free", or "Don\'t Show". We will not be able to apply No-Show Protection to these Services. Would you like to continue anyways? <br><br>For full protection please set Service pricing to "Fixed" or "Starts At".',
    'adjust-pricing': 'Adjust service pricing',
    'set-up-mobile-payments': 'Set Up Mobile Payments',
    'set-up-mobile-payments-text': 'In order to enable No-Show Protection you need to set up Mobile Payments. Please review your Payments settings to complete the necessary steps. Please note: pending changes will not be saved if you leave Service settings.',
    'no-thanks': 'No, thanks',
  },
  combo: {
    'no-combo-related': 'This service is not included in any Combo Services',
  },
  'service-type-bar': {
    title: 'Help clients find you.',
    text: 'Assign Service Types to your services to increase your chances of being found on Booksy.',
    'learn-more-button': 'Learn more',
    'assign-services-button': 'Assign Service Type',
    'almost-done': 'Almost done',
    'service-assigned': 'Service assigned: {assigned}/{total}',
    'continue-button': 'Continue',
  },
}
